<div class="customer-dialog">
  <div class="customer-dialog__header">
    <span class="customer-dialog__title">
      @if (customerDetails) {
        {{ 'updateCustomer' | translate }}
      } @else {
        {{ 'createCustomer' | translate }}
      }
    </span>
    <button
      type="button"
      mat-icon-button
      class="customer-dialog__close"
      (click)="onCancel()"
      [disabled]="isCreatingOrUpdatingCustomer">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="customer-dialog__body">
    <kzn-customer
      [isEdit]="!!customerDetails"
      [customerDetails]="customerDetails"
      #customerCompRef
    ></kzn-customer>
  </div>

  <div class="customer-dialog__actions">
    <button
      type="button"
      class="customer-dialog__cancel-btn"
      (click)="onCancel()"
      [disabled]="isCreatingOrUpdatingCustomer">
      {{ 'cancel' | translate }}
    </button>
    <button
      type="button"
      class="customer-dialog__submit-btn"
      (click)="createOrUpdateCustomer()"
      [class.spinner]="isCreatingOrUpdatingCustomer"
      [disabled]="isCreatingOrUpdatingCustomer">
      @if (customerDetails) {
        {{ 'saveChanges' | translate }}
      } @else {
        {{ 'createCustomer' | translate }}
      }
    </button>
  </div>
</div>
